import React, { FC } from 'react';
import { Alignment, HeadingOption, NumbersItem } from '../../types';
import { EditorialHeadline } from './EditorialHeadline';
import { Numbers } from './EditorialNumbers';

export interface NumbersModeProps {
  components: NumbersItem[][];
  headingOption?: HeadingOption;
  alignmentNumbers: Alignment;
  flexibleWidth?: boolean;
  textAlignment: Alignment;
}

export const NumbersMode: FC<NumbersModeProps> = ({
  components,
  headingOption,
  alignmentNumbers,
  flexibleWidth,
  textAlignment,
}) => {
  return (
    <>
      <EditorialHeadline
        headingOption={headingOption}
        testid="numbers-headline-container"
        alignment={textAlignment}
      />
      <Numbers
        components={components}
        alignmentNumbers={alignmentNumbers}
        flexibleWidth={flexibleWidth}
      />
    </>
  );
};
